const STATUSES = [
  { value: "registered", label: "Зарегистрирована" },
  { value: "completed", label: "Выполнена" },
  { value: "cancelled", label: "Отменена" },
];

export { STATUSES };
